import { LocaleMessages } from 'vue-i18n'

const APP_MESSAGES_APP_TITLE: string = process.env.VUE_APP_TITLE

const appPtBrLocaleMessages: LocaleMessages = {
  module: {
    app: APP_MESSAGES_APP_TITLE,
    auth: 'Autorização',
    bestzap: 'BestZap',
    doc: 'Documentos',
    flp: 'Folha de Pagamento',
    infra: 'Infraestrutura',
    notacerta: 'Nota Certa',
    payment: 'Pagamentos'
  },
  index: {
    field: {
      notifications: 'Notificações',
      settings: 'Configurações',
      themeDark: 'Tema escuro',
      language: 'Idioma',
      about: 'Sobre',
      client: '{title} App',
      server: '{title} Server',
      menu: 'Menu'
    }
  },
  crud: {
    field: {
      pageInfo: '{start}-{stop} de {totalSize}',
      options: 'Opções',
      auditingColumns: 'Colunas de auditoria',
      refreshTable: 'Recarregar tabela',
      itemsPerPage: 'Itens por página',
      auditingInputs: 'Campos de auditoria',
      refreshForm: 'Recarregar formulário'
    },
    alert: {
      search: 'Pesquisar',
      select: 'Selecione um item',
      typeOrSelect: 'Digite ou selecione um item',
      typeAndPressTab: 'Digite e pressione tab',
      delete: 'Tem certeza que deseja excluir este item?',
      download: 'Tem certeza que deseja baixar todos os itens?'
    },
    notification: {
      saved: 'Item salvo com sucesso.',
      deleted: 'Item excluído com sucesso.'
    },
    button: {
      fetch: 'Buscar dados',
      clear: 'Limpar dados'
    }
  },
  openExternal: {
    title: 'Abrir link'
  },
  routeNotFound: {
    title: 'Rota não encontrada'
  },
  viewNotImplemented: {
    title: 'Visualização não implementada'
  },
  auditing: {
    field: {
      id: 'Id',
      version: 'Versão',
      createdBy: 'Criado por',
      createdDatetime: 'Criado em',
      lastModifiedBy: 'Modificado por',
      lastModifiedDatetime: 'Modificado em'
    }
  },
  alert: {
    empty: 'Não há dados disponíveis'
  },
  rule: {
    email: 'Informe um e-mail válido.',
    max: 'Este campo deve conter no máximo {0} caracter(es).',
    min: 'Este campo deve conter no mínimo {0} caracter(es).',
    required: 'Este campo é obrigatório.'
  },
  notification: {
    updateServiceWorker: 'Nova atualização disponível.',
    updatedServiceWorker: 'App atualizado com sucesso.',
    requestNotificationPermission: 'Receba notificações do servidor.',
    grantedNotificationPermission: 'Notificações ativadas com sucesso.'
  },
  error: {
    status404: 'Dados não encontrados.',
    requestCanceledError: 'Solicitação cancelada pelo usuário.',
    networkError: 'Não foi possível conectar ao servidor.'
  },
  button: {
    ok: 'OK',
    enable: 'Ativar',
    update: 'Atualizar',
    download: 'Baixar',
    enter: 'Entrar',
    exit: 'Sair',
    send: 'Enviar',
    confirm: 'Confirmar',
    create: 'Criar',
    search: 'Pesquisar',
    open: 'Abrir',
    new: 'Novo',
    edit: 'Editar',
    delete: 'Excluir',
    save: 'Salvar',
    cancel: 'Cancelar'
  },
  value: {
    enabledDisabled: {
      true: 'Ativado',
      false: 'Desativado'
    },
    connectedDisconnected: {
      true: 'Conectado',
      false: 'Desconectado'
    },
    visibleHidden: {
      true: 'Visível',
      false: 'Oculto'
    }
  },
  vuetify: {
    badge: 'Distintivo',
    close: 'Fechar',
    dataIterator: {
      noResultsText: 'Nenhum item encontrado',
      loadingText: 'Carregando dados...'
    },
    dataTable: {
      itemsPerPageText: 'Itens por página',
      ariaLabel: {
        sortDescending: 'Ordenado decrescente.',
        sortAscending: 'Ordenado crescente.',
        sortNone: 'Não ordenado.',
        activateNone: 'Ative para remover a ordenação.',
        activateDescending: 'Ative para ordenar decrescente.',
        activateAscending: 'Ative para ordenar crescente.'
      },
      sortBy: 'Ordenar por'
    },
    dataFooter: {
      itemsPerPageText: 'Itens por página',
      itemsPerPageAll: 'Todos',
      nextPage: 'Próxima página',
      prevPage: 'Página anterior',
      firstPage: 'Primeira página',
      lastPage: 'Última página',
      pageText: '{0}-{1} de {2}'
    },
    datePicker: {
      itemsSelected: '{0} selecionado(s)',
      nextMonthAriaLabel: 'Próximo mês',
      nextYearAriaLabel: 'Próximo ano',
      prevMonthAriaLabel: 'Mês anterior',
      prevYearAriaLabel: 'Ano anterior'
    },
    noDataText: 'Não há dados disponíveis',
    carousel: {
      prev: 'Anterior',
      next: 'Próximo',
      ariaLabel: {
        delimiter: 'Slide {0} de {1} do carrossel'
      }
    },
    calendar: {
      moreEvents: 'Mais {0}'
    },
    fileInput: {
      counter: '{0} arquivo(s)',
      counterSize: '{0} arquivo(s) ({1} no total)'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Navegação de paginação',
        next: 'Próxima página',
        previous: 'Página anterior',
        page: 'Ir para a página {0}',
        currentPage: 'Página atual: {0}'
      }
    },
    rating: {
      ariaLabel: {
        icon: 'Avaliação {0} de {1}'
      }
    }
  }
}

export default appPtBrLocaleMessages